var exports = {
  "wrapper": "x9bf38834--7919e1--wrapper",
  "phone": "x9bf38834--7919e1--phone",
};

module.exports = exports;
